import LabelImportantRoundedIcon from '@mui/icons-material/LabelImportantRounded'
import PlaceIcon from '@mui/icons-material/Place'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Typography from '@mui/material/Typography'
import {blueGrey, grey, indigo} from '@mui/material/colors'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import {MPersonDetailGraphEntity} from 'app/modules/discovery/core/_models'
import {Link, useLocation} from 'react-router-dom'
import {useTracking} from 'react-tracking'
import ShowMoreText from './ShowMoreText'

export default function PersonResult({
  person,
  scrollPosition,
  search,
  fromDir,
  fromProject,
  page,
  busDetTab,
  showFullPerson,
}: {
  person: MPersonDetailGraphEntity
  scrollPosition?: number
  search?: string
  fromDir?: boolean
  fromProject?: boolean
  page?: number
  busDetTab?: string
  showFullPerson?: (businessId: string) => void
}) {
  const navigate = useAppNavigate()
  const location = useLocation()
  const {trackEvent} = useTracking<{entity: string; id: string}>()
  const route = `/people/detail?personId=${person.id}${
    scrollPosition ? `&scrollPosition=${scrollPosition}` : ''
  }${search || fromDir ? `&fromPersonDirectory=${search ? search : 'tru'}` : ''}${
    page ? `&page=${page}` : ''
  }${
    busDetTab
      ? `&retval=${
          location.pathname + location.search?.replaceAll('&', '+')
        }+busDetTab=${busDetTab}`
      : ''
  }`

  return (
    <Card elevation={0} sx={{p: 0, m: 0, mb: 2}}>
      <CardHeader
        sx={{p: 0, m: 0}}
        title={
          <>
            <Box display={'flex'}>
              {fromDir ? (
                <Link
                  className='text-hover-primary'
                  to={route}
                  onClick={() => {
                    trackEvent({entity: 'person', id: `${person.id}`})
                  }}
                  color={indigo[300]}
                  style={{fontWeight: 600, fontSize: '1em', color: indigo[300]}}
                >
                  {person?.name}
                </Link>
              ) : fromProject && showFullPerson ? (
                <Typography
                  variant='h6'
                  component='div'
                  fontWeight={600}
                  color={indigo[300]}
                  style={{cursor: 'pointer'}}
                  fontSize={'1em'}
                  onClick={() => person.id && showFullPerson(person.id)}
                >
                  {person?.name}
                </Typography>
              ) : (
                <Link className='text-hover-primary' to={`/people/detail?personId=${person.id}`}>
                  {person?.name}
                </Link>
              )}

              {person?.title && (
                <Box display={'flex'} ml={1} alignItems={'center'}>
                  <Typography
                    variant={'caption'}
                    fontWeight={600}
                    fontSize={'1.1rem'}
                    color={grey[700]}
                  >
                    <LabelImportantRoundedIcon sx={{mr: 0.5, fontSize: '1em'}} />
                    {person.title}
                  </Typography>
                </Box>
              )}
            </Box>
            {person.city && person.state && (
              <Box display={'flex'} flexDirection={'row'} alignItems={'baseline'}>
                <Typography color={grey[800]} ml={0.5}>
                  <PlaceIcon sx={{fontSize: '1em'}} /> {person.city}, {person.state}{' '}
                  {person.country}
                </Typography>
              </Box>
            )}
          </>
        }
      />
      <CardContent sx={{pt: 1, pb: '1 !important'}}>
        <Box display={'flex'} flexDirection={'column'}>
          {person?.description ||
            (person?.headline && (
              <Box sx={{color: blueGrey[400]}}>
                <ShowMoreText
                  variant={'h6'}
                  maxLen={300}
                  inheritColor={true}
                  text={person.description ? person.description : person.headline}
                  moreString='...Show More'
                  lessString='...Show Less'
                />
              </Box>
            ))}
        </Box>
      </CardContent>
    </Card>
  )
}
